import { render, staticRenderFns } from "./veJkyCategoryEdit.vue?vue&type=template&id=5f97b646&scoped=true"
import script from "./veJkyCategoryEdit.vue?vue&type=script&lang=js"
export * from "./veJkyCategoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f97b646",
  null
  
)

export default component.exports